if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function () {

    addSpanButtons()

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
    paragraph.forEach(e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    $("#email-signup").attr("token", "e4875c29-ddfc-44a7-9374-576a8090a123");
    $("#email-signup").on("submit", function(){ 
        setTimeout(function(){
            $("#email-signup").attr("id", "revinate_contact_api_form");
            $("#revinate_contact_api_form #email-signup_email_address").attr("name", "email");
            revFormOnSubmit();
        }, 1000)
    } );

    $('.sym-slides').slick({
        accessibility: true,
        autoplay: true,
        autoplaySpeed: 5000,
        responsive: [
            {
              breakpoint: 700,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
        ]
    });

    $('.sym-slides-home').slick({
        arrows:false,
        accessibility: true,
        autoplay: false,
        autoplaySpeed: 5000,
        dots:true,
        fade:true,
        appendDots: $('.slick-slider-dots')
    });

    $('.banner-slides').slick({
        arrows:false,
        accessibility: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 5000,
        dots:true,
        fade:true,
    });

    $('.sym-slides-home-white').slick({
        arrows:false,
        accessibility: true,
        autoplay: false,
        autoplaySpeed: 5000,
        dots:true,
        fade:true,
        appendDots: $('.slick-slider-dots')
    });

    $('.sym-slides-single').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        appendArrows:$('.winner_slider .winner_slider--arrow'),
        responsive: [
            {
              breakpoint: 700,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
        ]
    });

    $('.slider-three-columns-block-slides').slick({
        accessibility:true,
        slidesToShow : 3,
        autoplay:true,
        autoplaySpeed:4000,
        speed:400,
        adaptiveHeight: true,
        arrow: true,
        responsive: [
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow : 2,
                    infinite: true,
                }
            },
            {
                breakpoint: 700,
                settings: {
                    slidesToShow : 1,
                    fade:true,
                    adaptiveHeight: false
                }
            }
        ]
    })


    //custom dots 
    $('.js-slick-dots').each((i, dots) => {
        $('button', dots).click((e) => {
            let slideTo = $(e.currentTarget).data('goto');
            $(dots).closest('.sym-slides-home').slick('slickGoTo', slideTo);
        });
    });


    $('.reviews').slick({
        fade: true,
        accessibility: false,
    })

    $('.sym-slides-gallery').slick({
        dots: true,
        arrows:false,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });

    $('.js-slick-prev').click(function () {
        const $curSlider = $(this).data('target') ? $($(this).data('target')) : $(this).closest('.sym-slides');
        $curSlider.slick('slickPrev');
    });

    $('.js-slick-next').click(function () {
        const $curSlider = $(this).data('target') ? $($(this).data('target')) : $(this).closest('.sym-slides');
        $curSlider.slick('slickNext');
    });




    /* Function select menu */
    document.querySelectorAll('.js-menu-tab').forEach((btn) => {
        btn.addEventListener('click', _ => {
            $('.js-menu-tab.active').removeClass('active');
            $(btn).addClass('active');
            $('.quad-menus__menu-content.active').removeClass('active');
            var tabNumber = $(btn).attr('data-menuid');
            var tabToOpen = ".quad-menus__menu-content[data-menuid='" + tabNumber + "']";
            $(tabToOpen).addClass('active');
            $('.quad-menus__tabs-image.active').removeClass('active');
            var imgToOpen = ".quad-menus__tabs-image[data-menuid='" + tabNumber + "']";
            $(imgToOpen).addClass('active');
            $('.name-bg.active').removeClass('active');
            var wordToOpen = ".name-bg[data-menuid='" + tabNumber + "']";
            $(wordToOpen).addClass('active');
        });
    });


    /* Function DropDown */
    let ultimoDropdown;
    let dropdownList = document.querySelectorAll(".checkbox-dropdown-list");
    let dropdownFilters = document.querySelectorAll(".checkbox-dropdown");

    dropdownList.forEach((list) => {
        list.addEventListener('click', (e) => {
            e.stopPropagation();
        });
    });

    dropdownFilters.forEach((dropdown) => {
        dropdown.addEventListener('click', () => {
            dropdownFilters.forEach(dropdownHover => {
                if (dropdown != ultimoDropdown) {
                    dropdownHover.lastElementChild.classList.remove('hover');
                }
            })
            if (dropdown.lastElementChild.classList.contains('hover')) {
                dropdown.lastElementChild.classList.remove('hover');
            } else {
                dropdown.lastElementChild.classList.add('hover');
            }
            ultimoDropdown = dropdown;
        });
    });
    /* ------------------------ */

    /* Add span to all btns */
    function addSpanButtons() {
        document.querySelectorAll('.btn').forEach((ele) => {
            if (!ele.querySelector('span')) {
                var actualtext = ele.textContent;
                ele.innerHTML = `<span>${actualtext}</span>`;
            }
            ele.addEventListener('click', function (evento) {
                let hasHref = ele.hasAttribute('href');
                if (hasHref) {
                    let hrefTarget = ele.getAttribute('href');
                    if (hrefTarget.startsWith("#")) {
                        let elemTarget = document.querySelector(hrefTarget);
                        if (elemTarget && !ele.hasAttribute("data-fancybox")) {
                            evento.preventDefault();
                            elemTarget.classList.remove('hide');
                            $('html, body').animate({ scrollTop: $(elemTarget).offset().top - 100 }, 1000);
                        }
                    }
                }
            });
        });
    }

})();